export const PRICE = '23 USD'

export const BRAND = 'Hair Extension Instructor Ready™'

/** Interior pages from Volume 2, in the required order. Real pages are 4:5. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/3iXPKeiS1oxKN7LGY6nWJy/01_Pagina_7.webp',
    caption: 'Volume 2 — Page 7',
    label: 'Tape-In Demo & Sectioning Plans',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qTYeeiYgKqfszNtc2wpvij/02_Pagina_14.webp',
    caption: 'Volume 2 — Page 14',
    label: 'Ring Extension Application',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/xr5fAoD9GxBxxz3dgRdi6T/03_Pagina_17.webp',
    caption: 'Volume 2 — Page 17',
    label: 'Weft Placement & Sectioning',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mtjNcpEBczwJ4GFiKC1r9x/04_Pagina_36.webp',
    caption: 'Volume 2 — Page 36',
    label: 'Instructor Answer Key & Technical Evaluation',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/61XUcCv1Jm1jXAhkPFkMdh/05_Pagina_24.webp',
    caption: 'Volume 2 — Page 24',
    label: 'Quick Method Comparison',
  },
]

export const painPoints = [
  {
    title: 'Hours of Lesson Planning',
    text: 'Spending evenings organizing what to teach and how to teach it.',
  },
  {
    title: 'Starting From Scratch',
    text: 'Creating demonstrations, worksheets, and activities every time.',
  },
  {
    title: 'Repeating the Same Explanations',
    text: 'Struggling to give students a consistent, structured learning experience.',
  },
  {
    title: 'Scattered Teaching Materials',
    text: 'Keeping track of notes, practice exercises, and evaluations across different files.',
  },
]

export const solutionBenefits = [
  { title: 'Save Preparation Time', text: 'Work from structured materials instead of blank pages.', tint: '#F9DCD3' },
  { title: 'Teach With More Structure', text: 'Organize lessons, demonstrations, and practical activities.', tint: '#CFE4F5' },
  { title: 'Support Student Practice', text: 'Use exercises and worksheets to guide skill development.', tint: '#D5EEDC' },
  { title: 'Evaluate With Confidence', text: 'Track learning with checklists, rubrics, and assessment resources.', tint: '#E6D6F3' },
]

/** Accent colors match the covers in the mockup. */
export const volumes = [
  {
    number: 1,
    title: 'Hair Extension Education Foundations & Professional Essentials',
    description:
      'Build the foundation for structured hair extension education, including professional essentials, consultation principles, and teaching preparation.',
    accent: '#F9DCD3',
  },
  {
    number: 2,
    title: 'Professional Hair Extension Techniques & Installation Mastery',
    description: 'Explore professional extension methods, tools, installation principles, and demonstration guidance.',
    accent: '#F7CFCB',
  },
  {
    number: 3,
    title: 'Hair Extension Blending, Maintenance & Corrective Techniques',
    description: 'Teach blending considerations, maintenance, troubleshooting, and corrective decision-making.',
    accent: '#CFE4F5',
  },
  {
    number: 4,
    title: 'The Hair Extension Student Practice & Skills Workbook',
    description: 'Provide students with practical activities, exercises, and skill-development worksheets.',
    accent: '#D5EEDC',
  },
  {
    number: 5,
    title: 'The Ready-to-Teach Hair Extension Lesson System',
    description:
      'Access eight structured lessons with teaching guidance, demonstrations, activities, and assessment opportunities.',
    accent: '#E6D6F3',
  },
  {
    number: 6,
    title: 'The Hair Extension Instructor Assessment & Classroom System',
    description:
      'Organize student evaluations, practical rubrics, progress tracking, and classroom administration.',
    accent: '#F7E3B0',
  },
]

export const bonuses = [
  {
    number: 'Bonus 1',
    title: 'The Hair Extension Training Day Preparation Kit™',
    description: 'Organize equipment, materials, classroom setup, and training-day checklists.',
    accent: '#F9DCD3',
  },
  {
    number: 'Bonus 2',
    title: 'The Hair Extension Client Consultation & Aftercare Template Pack™',
    description: 'Access consultation, service-record, and client-care templates.',
    accent: '#D5EEDC',
  },
  {
    number: 'Bonus 3',
    title: 'The Hair Extension Student Communication Template Vault™',
    description: 'Use ready-to-adapt messages for enrollment, reminders, feedback, and follow-up.',
    accent: '#CFE4F5',
  },
  {
    number: 'Bonus 4',
    title: 'The Hair Extension Workshop Format & Schedule Pack™',
    description: 'Plan half-day, full-day, multi-day, and individual training formats.',
    accent: '#E6D6F3',
  },
  {
    number: 'Bonus 5',
    title: 'The Hair Extension Student Completion & Professional Presentation Kit™',
    description: 'Organize completion documents, portfolio materials, and professional student presentation resources.',
    accent: '#F7E3B0',
  },
]

export const beforeItems = [
  'Starting lessons from a blank page.',
  'Searching through scattered teaching notes.',
  'Creating new worksheets repeatedly.',
  'Improvising evaluations.',
  'Spending too much time preparing.',
]

export const afterItems = [
  'Following structured lesson resources.',
  'Keeping materials organized.',
  'Using prepared practice activities.',
  'Evaluating with clear checklists.',
  'Spending more time focused on students.',
]

export const audience = [
  { title: 'Hair Extension Instructors', text: 'Who want to organize lessons and practical training.' },
  { title: 'Beauty Academy Owners', text: 'Who need consistent teaching resources across their programs.' },
  { title: 'Salon Trainers', text: 'Who train team members in extension techniques.' },
  { title: 'Experienced Extension Professionals', text: 'Who are developing their own structured teaching approach.' },
]

export const offerIncludes = [
  '6 Digital Teaching Volumes',
  '5 Practical Bonus Resource Packs',
  'Structured Lesson Plans',
  'Extension Technique Guidance',
  'Student Worksheets & Practice Activities',
  'Assessment Rubrics & Checklists',
  'Classroom Organization Resources',
  'Instant Digital Access',
]

export const steps = [
  { title: 'Get Instant Access', text: 'Complete your purchase and access your digital resources.' },
  { title: 'Explore Your Materials', text: 'Download the volumes, worksheets, lesson plans, and bonuses.' },
  {
    title: 'Prepare Your Next Class',
    text: 'Select the relevant materials and adapt them to your students, methods, and teaching environment.',
  },
]

export const faqs = [
  {
    question: 'Is this a physical product?',
    answer: 'No. Hair Extension Instructor Ready™ is a digital collection of PDF educational resources.',
  },
  {
    question: 'Who is this product for?',
    answer: 'It is designed for hair extension instructors, beauty educators, salon trainers, and academy owners.',
  },
  {
    question: 'Does it include installation techniques?',
    answer:
      'Yes. The collection includes teaching guidance covering professional extension techniques and installation principles.',
  },
  {
    question: 'Does it include ready-to-teach lessons?',
    answer: 'Yes. Volume 5 contains eight structured lessons designed to help organize classroom instruction.',
  },
  {
    question: 'Are there student practice materials?',
    answer: 'Yes. The collection includes student exercises, worksheets, checklists, and assessment resources.',
  },
  {
    question: 'Can I use this to train beginners?',
    answer:
      "The resources can support beginner-level instruction when adapted by a qualified educator to the students' prerequisites and the relevant methods.",
  },
  {
    question: 'Does this provide an official teaching certification?',
    answer: 'No. This is a teaching-resource collection, not an accredited qualification or professional license.',
  },
  {
    question: 'Is the payment secure?',
    answer:
      'Yes. Checkout is secure and encrypted, and your payment is processed automatically in your local currency.',
  },
  {
    question: 'How will I receive the product?',
    answer:
      'The collection is delivered digitally through the purchase platform. Access instructions are provided during checkout.',
  },
]
